/**
 * 药品类型
 * @param str
 * @returns {string}
 */
import {PRODUCE_TYPE_LIST, RECIPE_TYPE} from "@/lib/config";

export const filter_drug_type = (str) => {
    if (!str) return str
    const orderType = RECIPE_TYPE
    return orderType[str]
}

export const filter_produce_type = (str) => {
    if (!str) return str
    for (let type of PRODUCE_TYPE_LIST) {
        if (type.value === str) return type.label
    }
    return str;
}
